import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
// import { useTranslateContext } from 'gatsby-plugin-translate'

import MenuItem from './MenuItem'

import * as S from './styled'

const MenuContainer = () => {
  const data = useStaticQuery(graphql`
    query {
      Menu: allWordpressAltaThemeHeader {
        nodes {
          sidebars {
            widgets {
              value {
                name
                items {
                  title
                  url
                  wordpress_children {
                    title
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  // const { language } = useTranslateContext()

  const menuData = data.Menu.nodes[0].sidebars[0].widgets[0].value.items
  // tradução
  // const menuData =
  //   language === 'pt-br'
  //     ? data.Menu.nodes[0].sidebars[0].widgets[0].value.items
  //     : data.MenuEn.nodes[0].sidebars[0].widgets[0].value.items

  return (
    <S.MenuDesktop>
      <MenuItem menuData={menuData} />
    </S.MenuDesktop>
  )
}

export default MenuContainer
